const Upgrade = (app) => {
  app.get("/upgrade", ({ res, locals, flash, momentTZ }) => {
    res.redirect("/upgrade-1");
  });
};

export default Upgrade;
